<template>
  <div class="assets">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang36') }}</span>
    </div>
    <!-- <div class="navbar">
      <span v-for="(item, index) in navList" :key="index" @click="changeNav(item, index)" :style="{ color: navIndex == index ? '#000' : '' }">{{ item.key }}</span>
    </div> -->
    <div class="pd">
      <!-- <div class="total_box">
          <div>
            <span class="text">{{ $t('lang80') }}({{ $t('lang174') }})</span>
          </div>
          <div class="total">
            <span>{{ Math.floor(assets * 100) / 100 || 0 }}</span>
          </div>
          <div class="buy_box">
            <div class="buy" @click="navigation('recharge')">
              <van-button class="buy_btn" type="primary">{{ $t('lang138') }}</van-button>
            </div>
            <div class="buy" @click="navigation('sendChaBao')">
              <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
            </div>
            <div class="buy" @click="navigation('withdraw')">
              <van-button class="buy_btn" type="primary">{{ $t('lang113') }}</van-button>
            </div>
          </div>
        </div> -->

      <div class="bare" v-if="coinList.length <= 0">
        <span>{{ $t('lang82') }}</span>
      </div>
      <div class="list" v-else>
        <div v-for="(item, index) in coinList" :key="index" class="li" @click="navigatorToPage('share', { coin_type: item.coin_key })">
          <div class="li_left">
            <img :src="require('@/assets/images/index/' + item.coin_key + '.png')" class="li_img" />
            <span class="title">{{ item.coin_name }}</span>
          </div>
          <div class="box">
            <div class="box_item">
              <span class="key">{{ $t('lang83') }}</span>
              <span class="num">{{ item.amount || 0 }}</span>
            </div>
            <div class="box_item">
              <span class="key">{{ $t('lang336') }}</span>
              <span class="num">{{ item.frozen_amount || 0 }}</span>
            </div>
            <!-- <div class="box_item">
                  <span class="key">{{ $t('lang85') }}(CNY)</span>
                  <span class="num">{{ Math.floor(item.amount * Number(item.convert_rate) * 100) / 100 || 0 }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import { areaList } from '@vant/area-data';
import { Dialog, Notify, Toast } from 'vant';
export default {
  data() {
    return {
      loading: false,
      finished: false,
      total: 1,
      assets: 0,
      coinList: [],
      showPopover: false,
      actionType: -1, //-1:全部 0:未知 1:租赁 2:直推奖励 3:团队的算力奖励 4:团队的平级算力奖励
      navIndex: 0,
      navList: [
        {
          key: this.$t('lang134'),
          value: 0,
        },
        {
          key: this.$t('lang185'),
          value: 1,
        },
      ],
      areaList: areaList,
      page: 1,
      item: {},
      transfes_fee: 0, //寄售费率
      transfes_txt: '', //寄售手续费说明
      giveAddress: '', //赠送接收人钱包地址
      giveaway: 0, //赠送手续费率
      giveaway_txt: '', //赠送手续费说明
    };
  },
  mounted() {
    this.actionGet();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    navigatorToPage(name, query) {
      this.$router.push({ name, query });
    },
    navigation(name) {
      this.$router.push({ name });
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },

    actionGet() {
      homeApi.assets().then(res => {
        if (res.code == 200) {
          this.assets = res.data.assets;
          this.transfes_txt = res.data.transfes_txt;
          this.transfes_fee = res.data.transfes_fee;
          this.giveaway = res.data.giveaway;
          this.giveaway_txt = res.data.giveaway_txt;
          this.coinList = res.data.coin_list;
        }
      });
    },
    noopen() {
      this.$toast(this.$t('lang2'));
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.2px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  height: 50px;
  z-index: 999;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f-r {
  display: flex;
  align-items: center;
}
.f {
  display: flex;
}
.f-s {
  display: flex;
  align-items: flex-start;
}
.btn_box {
  padding-top: 14px;
}
.assets {
  min-height: 100vh;
  padding: 50px 0 0;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .navbar {
    position: fixed;
    top: 50px;
    z-index: 999;
    width: 100%;
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
    }
  }
  .pd {
    min-height: 100vh;
    padding: 4px;
    // margin-top: 54px;
    background-color: #fff;
  }
  .total_box {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    // position: relative;
    font-size: 12px;
    color: #fff;
    height: 140px;
    // border-radius: 16px;
    padding: 20px 20px 40px;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 10px;
    background: linear-gradient(to right, #1ab986, #25d7bb);

    .total {
      font-size: 28px;
      text-align: center;
      padding-top: 10px;
    }
    .text {
      color: rgba(#fff, 0.8);
    }
    .buy_box {
      position: absolute;
      bottom: 14px;
      display: flex;
      width: 100%;
      padding: 0 14px;
      align-items: center;
      justify-content: space-between;
    }
    .buy {
      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }
  .balance_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    margin: 0 6px;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    .balance_li {
      color: #510fa8;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 48%;
      font-size: 13px;
      border-radius: 16px;
      padding: 16px 0;
      // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.59);
      // background-color: rgba(255, 255, 255, 0.3);

      .icon {
        width: 20px;
        height: 20px;
        margin-bottom: 10px;
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 110px 14px 60px;
    color: #aaa;
  }
  .list {
    border-radius: 20px;
    padding: 0 8px;
    margin-top: 16px;
    background-color: #fff;
    margin: 0 6px 16px;
    .li {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 14px 0;

      .li_left {
        display: flex;
        align-items: center;
        .imgbox {
          width: 40px;
          height: 40px;
          border-radius: 15px;
          background-color: #f1f1f1;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 6px;
        }
        .li_img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        .title {
          color: #29b286;
          font-size: 15px;
          font-weight: bold;
        }
      }
      .box {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_item {
          width: 33%;
          display: flex;
          flex-direction: column;
          .key {
            color: #aaa;
            font-size: 12px;
          }
          .num {
            font-size: 14px;
            color: #000;
            padding-top: 2px;
          }
        }
        .box_item:last-child {
          text-align: right;
        }
      }
    }
  }

  .goods_box {
    // margin: 14px;
    height: 100vh;
    overflow: auto;
    border-radius: 14px;
    .good_icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .pd1 {
    padding: 64px 14px 14px;
  }
  .goods_list {
    position: relative;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    color: #000;
    padding: 14px;
    border-radius: 6px;
    // box-shadow: 0 4px 16px 0 rgba(53, 73, 93, 0.15);
    margin-bottom: 16px;
    // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    background-color: #fff;
    // background-image: linear-gradient(90deg, rgba(217, 239, 239, 0.3) 0, rgba(217, 239, 239, 0.3) 0, rgba(225, 240, 242, 0.3) 100%, rgba(225, 240, 242, 0.3) 100%);

    .tags {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 10px;
      color: #fff;
      padding: 4px 14px;
      z-index: 99;
      background-color: #29b2b0;
      border-radius: 6px 0 6px 0;
    }
    .tags1 {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 10px;
      color: #fff;
      padding: 4px 14px;
      z-index: 99;
      background-color: #f4ab1e;
      border-radius: 6px 0 6px 0;
    }
    .tags3 {
      position: absolute;
      left: 6px;
      top: 6px;
      z-index: 99;
      font-size: 15px;
    }
    .tags2 {
      background-color: #1e8df4;
    }
    &_img {
      width: 105px;
      height: 105px;
      border-radius: 10px;
      margin-right: 10px;
    }

    .right {
      width: calc(100% - 115px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 13px;
      box-sizing: border-box;
      padding: 6px 0;
      .title {
        width: 100%;
        overflow: hidden; /* 确保超出容器的文本被裁剪 */
        white-space: nowrap; /* 确保文本在一行内显示 */
        text-overflow: ellipsis; /* 使用省略号表示文本超出 */
      }

      .time_text {
        color: #7f7f7f;
        font-weight: normal;
        font-size: 10px;
        text-decoration: line-through;
      }
      .cen {
        color: #000;

        font-size: 12px;
      }
      .money {
        font-size: 15px;
      }
      .ssm {
        font-size: 10px;
        font-weight: normal;
      }
      .mon_t {
        color: #3d3d3d;
        font-weight: normal;
      }
      .yel {
        background-color: #f9f6e5;
        font-weight: normal;
        margin-left: 8px;
        padding: 0px 8px;
        border-radius: 16px;
        white-space: nowrap;
        .count {
          color: #f7c35d;
          font-size: 9px;
        }
      }
      .green {
        width: fit-content;
        color: #29b286;
        background-color: #ddf2e7;
        font-size: 10px;
        font-weight: normal;
        padding: 2px 6px;
        border-radius: 6px;
      }
      .t2 {
        text-decoration: none;
      }
    }
    .buy {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      &_btn {
        height: 32px;
        width: 76px;
        text-align: center;
        line-height: 32px;
        font-size: 12px;
        border: none;
        // padding: 0 20px;
        white-space: nowrap;
        border-radius: 30px;
        box-sizing: border-box;
        // padding: 0 10px;
        // overflow: hidden; /* 确保超出容器的文本被裁剪 */
        // white-space: nowrap; /* 确保文本在一行内显示 */
        // text-overflow: ellipsis; /* 使用省略号表示文本超出 */
        border: 1px solid #29b286;
        background-color: #29b286;
      }
      .btn1 {
        color: #29b286;
        background-color: #fff;
      }
      .btn3 {
        width: 98px;
        color: #b9b9b9;
        padding: 0 20px;
        border: 1px solid #b9b9b9;
        background-color: #fff;
      }
      .btn4 {
        width: 96px;
      }
    }
    .buy1 {
      justify-content: flex-end;
    }
  }
  .area {
    color: #363636;
    font-size: 13px;
    padding: 20px 30px;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    .title {
      color: #000;
      font-size: 15px;
      text-align: center;
      font-weight: bold;
      // padding: 0 0 14px;
    }
    .vanlist {
      max-height: 350px;
      overflow: auto;
      box-sizing: border-box;
      margin: 20px 0;
      border: none !important;

      .item {
        padding: 12px 0 !important;
        border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);
      }
    }
    .box {
      margin: 20px 0;
      .f-r,
      .f-s {
        padding: 6px 0;
      }
      .f-r span:first-child,
      .f-s span:first-child {
        padding-right: 8px;
        white-space: nowrap;
      }
      .d {
        display: flex;
        align-items: flex-end;
      }
      .input {
        // width: 100%;
        // border: 1px solid #29b286;
        // border-radius: 20px;
        width: 150px;
        border-bottom: 0.5px solid rgba(27, 27, 27, 0.15);
      }
      .k {
        padding-top: 6px;
      }
      .input1 {
        width: 100%;
        border-bottom: 0.5px solid rgba(27, 27, 27, 0.15);
        // ::v-deep .van-field__body,
        // ::v-deep .van-field__control {
        //   height: 32px !important;
        // }
      }

      .van-cell {
        padding: 0 !important;
      }
      .s {
        font-size: 11px;
        color: #999999;
        width: 70%;
      }
    }
    .submit {
      width: 100%;
      // position: fixed;
      bottom: 30px;
      box-sizing: border-box;
      &_btn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        background-color: #29b286;
        border: none;
        white-space: nowrap;
        border-radius: 30px;
      }
    }

    ::v-deep .van-field__control {
      padding: 0 12px 0;
      font-size: 12px;
    }

    ::v-deep .van-hairline--top-bottom::after,
    ::v-deep.van-hairline-unset--top-bottom::after {
      border: none;
    }
  }
}
::v-deep .van-cell {
  padding: 10px 0 !important;
}
::v-deep .van-button--danger {
  background-color: #29b286;
  border-color: #29b286;
}
::v-deep .van-address-edit {
  padding: 10px 0;
}
::v-deep .van-ellipsis {
  font-size: 10px !important;
}
::v-deep .van-overlay {
  background-color: rgba(#000, 0.3);
}
::v-deep van-hairline-unset--top-bottom,
::v-deep .van-picker__frame {
  border: 1px solid #fff !important;
}
</style>